import { Navigate } from "react-router-dom";
import {useAuth} from "../components/context/AuthContext";


const RoleRoute = ({ children }) => {
    const { user, isAdmin, loading } = useAuth();

    if (loading) return <h2>Loading...</h2>;

    if (!user || !isAdmin) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

export default RoleRoute;
